import * as React from "react";
import { Stack, Heading } from "@origin-digital/ods-core";
import FormFieldLayout from "../FormComponents/FormFieldLayout";
import { useFormikContext } from "formik";
import { ChangeRequestFormValues } from "./formValue";
import ReadOnlyFieldWrapper from "../ReadOnlyFieldWrapper";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import { getFormattedAddress } from "src/components/Premises/helpers";
import { PremiseDetails } from "src/components/Premises/types";
import {
  energyTypeOptions,
  getFullName,
  mapToLabel,
  relationshipOptions,
} from "./helpers";
import { useAppContext } from "src/context/AppContext";

const ChangeRequestPremiseBlockReadonly: React.FC<{
  isSubmitted: boolean;
  isDraft: boolean;
}> = ({ isSubmitted, isDraft }) => {
  const { values } = useFormikContext<ChangeRequestFormValues>();
  const {
    context: { user },
  } = useAppContext();
  const { noCompany } = values;

  return (
    <Stack
      space={{
        xs: "xlarge",
        md: "xxlarge",
      }}
      id="premiseReadonlySection"
    >
      <Heading variant="h4">Premises</Heading>
      {!noCompany && (
        <FormFieldLayout>
          <ReadOnlyFieldWrapper value={values.requestingCompany?.name}>
            <ReadOnlyTextField
              label="Requesting company"
              value={values.requestingCompany?.name}
            />
          </ReadOnlyFieldWrapper>
        </FormFieldLayout>
      )}

      {noCompany && (
        <FormFieldLayout>
          <ReadOnlyTextField
            label="Requestor name"
            value={
              isDraft
                ? values.requesterName ||
                  getFullName(user?.first_name ?? "", user?.last_name ?? "")
                : values.requesterName ?? ""
            }
          />
        </FormFieldLayout>
      )}

      {noCompany && (
        <FormFieldLayout>
          <ReadOnlyTextField
            label="Requestor email"
            value={
              isDraft
                ? (values.requesterEmail || user?.email) ?? ""
                : values.requesterEmail ?? ""
            }
          />
        </FormFieldLayout>
      )}

      <ReadOnlyFieldWrapper value={values.relationship}>
        <FormFieldLayout>
          <ReadOnlyTextField
            label="What’s your relationship to the property?"
            value={mapToLabel(values.relationship, relationshipOptions)}
          />
        </FormFieldLayout>
      </ReadOnlyFieldWrapper>
      <ReadOnlyFieldWrapper value={values.energyType}>
        <FormFieldLayout>
          <ReadOnlyTextField
            label="Which energy type?"
            value={mapToLabel(values.energyType, energyTypeOptions)}
          />
        </FormFieldLayout>
      </ReadOnlyFieldWrapper>
      <ReadOnlyFieldWrapper value={values.nmi}>
        <FormFieldLayout>
          <ReadOnlyTextField label="NMI" value={values.nmi} />
        </FormFieldLayout>
      </ReadOnlyFieldWrapper>

      {values.premise && (
        <ReadOnlyFieldWrapper value={values.premise}>
          <FormFieldLayout>
            <ReadOnlyTextField
              label="Address"
              value={getFormattedAddress(values.premise as PremiseDetails)}
            />
          </FormFieldLayout>
        </ReadOnlyFieldWrapper>
      )}

      {isSubmitted && (
        <FormFieldLayout>
          <ReadOnlyTextField
            label="Supply Service Order Number"
            value={values.supplyServiceOrderNumber || "Pending"}
          />
        </FormFieldLayout>
      )}
    </Stack>
  );
};

export default ChangeRequestPremiseBlockReadonly;
